import { Pipe, PipeTransform } from '@angular/core';

import { format, isDate, isValid } from 'date-fns';

@Pipe({
    name: 'datefns'
})
export class DateFnsPipe implements PipeTransform {
    transform(value: Date | string, formatStr?: string) {
        if (value == null || value === '') { return ''; }

        let dateval: Date = null;

        dateval = (isDate(value) ? <Date>value : new Date(<string>value));

        if (!isValid(dateval)) { return value; }

        return (formatStr ? format(dateval, formatStr) : dateval.toDateString());
    }
}
